import React, { Component, Fragment } from "react";

export default class Navbar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <nav className="navbar navbar-dark bg-primary sticky-top ">
                    <div className="container-fluid flex-wrap">
                        <a className="navbar-brand" href="/">Relatório da produção de STI do SENAI</a>
                        <ul className="navbar-nav flex-row flex-wrap">
                            <li className="nav-item">
                                <a className="nav-link active text-white px-2" aria-current="page" href="/">Início</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href="/relatorio2">Relatório Dinâmico</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href="/upload">Upload</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </Fragment>
        )
    }
}